<template>
  <div class="relative bg-black text-gray-50 bg-grid-white" id="stats">
    <div class="flex flex-col items-center px-6 py-24 mx-auto text-center max-w-7xl">
      <div class="grid w-full gap-4 mt-4 sm:grid-cols-2 lg:grid-cols-4">
        <div class="p-6 bg-gray-700 bg-opacity-25 rounded-lg">
          <div class="text-4xl font-bold">
            {{ (stats.orders / 1000).toFixed(2) + 'k' }}+
          </div>
          <div class="text-xs font-medium tracking-wider text-gray-300 uppercase">
            Orders Captured
          </div>
        </div>
        <div class="p-6 bg-gray-700 bg-opacity-25 rounded-lg">
          <div class="text-4xl font-bold">
            {{ (stats.notifications / 1000).toFixed(2) + 'k' }}+
          </div>
          <div class="text-xs font-medium tracking-wider text-gray-300 uppercase">
            Notifications Sent
          </div>
        </div>
        <div class="p-6 bg-gray-700 bg-opacity-25 rounded-lg">
          <div class="text-4xl font-bold">
            {{ (stats.coordinates / 1000000).toFixed() + 'M' }}+
          </div>
          <div class="text-xs font-medium tracking-wider text-gray-300 uppercase">
            Coordinates Tracked
          </div>
        </div>
        <div class="p-6 bg-gray-700 bg-opacity-25 rounded-lg">
          <div class="text-4xl font-bold">
            {{ stats.orders }}+
          </div>
          <div class="text-xs font-medium tracking-wider text-gray-300 uppercase">
            Estimated Manhours Saved
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stats',

  created () {
    this.fetchStats()
  },

  data () {
    return {
      stats: {
        orders: 0,
        notifications: 0
      }
    }
  },

  methods: {
    async fetchStats () {
      const { data } = await this.$api.get('site/stats')
      this.stats = data
    }
  }
}
</script>